import { createSupplierDetailState } from '@/composables/suppliers/supplierDetail/state';
import { supplierDetailComputed } from '@/composables/suppliers/supplierDetail/computed';
import { supplierDetailCoreMethods } from '@/composables/suppliers/supplierDetail/methods/core';
import { supplierDetailExpenseMethods } from '@/composables/suppliers/supplierDetail/methods/expenses';
import { supplierDetailFeeMethods } from '@/composables/suppliers/supplierDetail/methods/fees';

export { createSupplierDetailState, supplierDetailComputed };

export const supplierDetailMethods = {
  ...supplierDetailCoreMethods,
  ...supplierDetailExpenseMethods,
  ...supplierDetailFeeMethods,
};
